import { model as userMarketingEmailOptInModel } from "@/feature-auth/models/marketing-email-opt-in-model.mjs";
import { model as userPreferencesModel } from "@/feature-auth/models/user-preferences-model.mjs";
import gql from "@/util/graphql-query.mjs";

export const UpdateUserPreferences = gql`
  mutation UpdateUserPreferences($preferences: Map!) {
    updateUserPreferences(preferences: $preferences, isDeltaUpdate: true) {
      ${userPreferencesModel}
    }
  }
`;

export const UserMarketingEmailOptIn = gql`
  query FindUserOptIn($userId: ID!) {
    findUserOptIn(userId: $userId) { ${userMarketingEmailOptInModel} }
  }
  `;

export const UpdateUserMarketingEmailOptIn = gql`
  mutation CreateOrUpdateUserOptIn($optedIn: Boolean!) {
    createUserOptIn(optedIn: $optedIn) { ${userMarketingEmailOptInModel} }
  }
`;
